import { render } from "./NotAutorizedView.vue?vue&type=template&id=0d757419&scoped=true&ts=true"
import script from "./NotAutorizedView.vue?vue&type=script&lang=ts"
export * from "./NotAutorizedView.vue?vue&type=script&lang=ts"

import "./NotAutorizedView.vue?vue&type=style&index=0&id=0d757419&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d757419"]])

export default __exports__